// key = feature flag comes in from API
// value = what feature flag is named in the app
export const FEATURE_FLAG_API_DICTIONARY = {
  FEATURE_PROGRAMPARTNERS: "showProgramPartnersFeature",
  FEATURE_PROCESSEDCLAIMSFILTER: "showProcessedClaimsFilterOption",
  FEATURE_INSIGHTSCHART: "showInsightsChart",
  FEATURE_PROGRAMPARTNERSSTATS: "showProgramPartnersStats",
  FEATURE_LAUNCH_DARKLY_CLIENT_SIDE_ID: "launchDarklyClientSideId",
  LOOKER_EMBED_HOST: "lookerEmbedHost"
};
